import {Component, inject, input, signal} from '@angular/core';
import {RouterLink} from "@angular/router";
import {animate, group, query, state, style, transition, trigger} from "@angular/animations";
import {SideNavigationService} from "../../service/side-navigation.service";
import {toSignal} from "@angular/core/rxjs-interop";

@Component({
  selector: 'bs-menu-item',
  imports: [
    RouterLink
  ],
  templateUrl: './bs-menu-item.component.html',
  styleUrl: './bs-menu-item.component.css',
  standalone: true,
  animations: [
    trigger('myInsertRemoveTrigger', [
      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('200ms ease-in', style({ height: '*', opacity: 1 })),
      ]),
      transition(':leave', [
        style({ height: '*', opacity: 1 }),
        animate('200ms ease-out', style({ height: 0, opacity: 0 })),
      ])
    ]),
    // trigger('myInsertRemoveTrigger', [
    //   transition(':enter', [
    //     style({ height: 0, opacity: 0 }),
    //
    //     query('.router-menu-item', [
    //       style({ translate: '0 -100%' })
    //     ]),
    //     group([
    //       animate('250ms ease-in', style({ height: '*', opacity: 1 })),
    //       query('.router-menu-item', [
    //         animate('250ms ease-in', style({ translate: '0 0' }))
    //       ])
    //     ])
    //   ]),
    //   transition(':leave', [
    //     style({ height: '*', opacity: 1 }),
    //     animate('250ms ease-out', style({ height: 0, opacity: 0 })),
    //   ])
    // ]),
  ],

  // animations: [transition('open <=> closed', [animate('0.5s')]),
  // ]
})
export class BsMenuItemComponent {
  sideNavigationService = inject(SideNavigationService);
  // showSideNavAsDialog = toSignal(this.sideNavigationService.sideNavigationIsDialog$);

  routerLink = input<any>();
  label = input<any>();
  items = input<any>();
  isSelected = input<boolean>();

  showDropDownItems = signal(false);

  toggleDropDownItems(){
    if(this.items()){
      this.showDropDownItems.update(x => !x);
    }
  }

  closeSideNavIfRouterLink(routerLink){
    // if(routerLink && this.showSideNavAsDialog()){
      // this.sideNavigationService.closeSideNav()
    // }
  }

}
